import React from 'react';
import { SortingDirection } from 'next-common';

export const useSortableData = (items, config = null) => {
  const [sortConfig, setSortConfig] = React.useState(config);

  const sortedItems = React.useMemo(() => {
    const sortableItems = [...items];
    const getDateFromString = (strDate) => {
      const dateParts = strDate.split('T');
      return new Date(dateParts[0]);
    };
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        let itemA = a[sortConfig.key];
        let itemB = b[sortConfig.key];
        if (sortConfig.key === 'invoiceDate') {
          itemA = getDateFromString(a[sortConfig.key]);
          itemB = getDateFromString(b[sortConfig.key]);
        }
        let variable = 0;
        variable = itemA < itemB && sortConfig.direction === SortingDirection.ASC ? -1 : 1;
        return variable;
      });
    }
    return sortableItems;
  }, [items, sortConfig]);

  const requestSort = (key) => {
    let direction = SortingDirection.ASC;
    if (sortConfig && sortConfig.key === key && sortConfig.direction === SortingDirection.ASC) {
      direction = SortingDirection.DESC;
    }
    setSortConfig({ key, direction });
  };

  return { items: sortedItems, requestSort, sortConfig };
};
